module.exports = __webpack_public_path__ + "static/media/Icons-20x20-Password_mostra_Light Blue.8f762e87.svg";